import { render } from "./photoListAll.vue?vue&type=template&id=c2b047bc&scoped=true&ts=true"
import script from "./photoListAll.vue?vue&type=script&lang=ts"
export * from "./photoListAll.vue?vue&type=script&lang=ts"

import "./photoListAll.vue?vue&type=style&index=0&id=c2b047bc&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2b047bc"]])

export default __exports__